import classNames from "classnames";
import { useField } from "formik";
import React, { ReactElement, ReactNode } from "react";

const BillingInputField = (props: any): ReactElement => {
  const [field, meta] = useField(props);
  const {
    label,
    labeled,
    placeholder,
    icon,
    containerClassName,
    flat,
    ...rest
  } = props;

  const { touched, error } = meta;
  const hasError = !!(meta.error && meta.touched);

  // Flat variant: clean, compact input (white bg, soft gray border, no glass/pill/icon).
  // Used by the desktop "Obtén tu entrada" modal; the label is rendered ABOVE by the caller.
  if (flat) {
    return (
      <div className={classNames("relative w-full pb-[10px]", containerClassName)}>
        <input
          {...field}
          {...rest}
          placeholder={placeholder}
          className={classNames(
            "w-full h-[44px] rounded-[12px] px-4 border text-[15px] text-gray-900",
            // Experimento Luma: fondo gris MUY sutil DENTRO del campo (clase
            // .booking-field-fill en globals.css → calibrable en un solo lugar). Sin sombra;
            // no toca bordes/radios/tamaños ni los colores de texto/placeholder.
            "booking-field-fill outline-none transition-all placeholder:text-gray-400",
            // type=number: ocultar spinners para que iguale a los inputs de texto.
            "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
            "focus:border-tikipal-orange focus:ring-2 focus:ring-tikipal-orange/15",
            hasError ? "border-red-400" : "border-gray-200/70 hover:border-gray-300"
          )}
        />
        {/* Sin mensaje de error inline (el requisito se indica con el asterisco en el
            label). La validación/obligatoriedad sigue intacta; solo se oculta el texto. */}
      </div>
    );
  }

  return (
    <div className={classNames("relative group/field pb-6 w-full", containerClassName)}>
      {labeled && (
        <label className="absolute -top-2.5 left-4 bg-white/80 backdrop-blur-sm px-2 text-[10px] font-black text-gray-400 uppercase tracking-widest group-focus-within/field:text-tikipal-orange transition-colors z-10 rounded-full border border-gray-100 flex items-center gap-1.5">
          {icon}
          {label}
        </label>
      )}
      <input
        {...field}
        {...rest}
        placeholder={placeholder}
        className={classNames(
          "w-full h-14 border rounded-[14px] px-4",
          "bg-white/10 backdrop-blur-xl",
          "outline-none text-[14px] text-gray-900 font-medium",
          "group-focus-within/field:border-tikipal-orange/60",
          "group-focus-within/field:ring-4 group-focus-within/field:ring-tikipal-orange/5",
          "transition-all duration-300",
          "shadow-[inset_0_2px_4px_rgba(0,0,0,0.02)]",
          "placeholder:text-gray-300",
          {
            "border-white/50": !(meta.error && meta.touched),
            "border-red-500": !!(meta.error && meta.touched),
          }
        )}
      />
      {touched && !!error?.length && (
        <div className="text-red-700 absolute bottom-1 text-xs">{error}</div>
      )}
    </div>
  );
};

export default BillingInputField;
